import { Component } from '@angular/core';

@Component({
  selector: 'no-results',
  templateUrl: './no-results.component.html',
  styleUrl: './no-results.component.scss'
})
export class NoResultsComponent {}
